(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lmp-home-principle"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lmp-home-story-switch')) {
 customElements.define('lmp-home-story-switch', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const signal = this.controller.signal;
   const panels = [...this.querySelectorAll('[data-home-panel]')];
   const updateTracks = () => this.querySelectorAll('[data-story-track]').forEach(track => track.dispatchEvent(new Event('scroll')));
   this.querySelectorAll('[data-home-choice]').forEach(choice => choice.addEventListener('change', updateTracks, { signal }));
   this.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[data-home-panel]');
    if (!panel) return;
    const choice = [...this.querySelectorAll('[data-home-choice]')].find(input => input.value === panel.dataset.homePanel);
    if (choice) { choice.checked = true;updateTracks(); }
   }, { signal });
   panels.forEach(panel => {
    const track = panel.querySelector('[data-story-track]');
    const prev = panel.querySelector('[data-story-prev]');
    const next = panel.querySelector('[data-story-next]');
    const count = panel.querySelector('[data-story-count]');
    panel.querySelector('[data-story-controls]').hidden = false;
    const update = () => {
     const children = [...track.children];
     if (!children.length || !track.clientWidth) return;
     const start = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft);
     let closest = 0;let distance = Infinity;
     children.forEach((item, i) => { const d = Math.abs(item.getBoundingClientRect().left - start);if (d < distance) { distance = d;closest = i; } });
     count.textContent = `${closest + 1} / ${children.length}`;
     prev.disabled = track.scrollLeft <= 2;
     next.disabled = track.scrollWidth - track.clientWidth - track.scrollLeft <= 2;
    };
    track.addEventListener('scroll', update, { passive:true, signal });
    const move = direction => {
     const first = track.children[0];if (!first) return;
     const amount = first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
     track.scrollBy({ left:amount * direction, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    prev.addEventListener('click', () => move(-1), { signal });
    next.addEventListener('click', () => move(1), { signal });
    const observer = new ResizeObserver(update);observer.observe(track);
    signal.addEventListener('abort', () => observer.disconnect(), { once:true });
    update();
   });
  }
  disconnectedCallback() { this.controller?.abort();this.controller = null; }
 });
}

  } catch(e) { console.error(e); }
})();
})();
